import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {MxInformationTooltipConfig} from '../../modules/mx-info-tooltip/components/mx-info-tooltip.component';


export interface MxInformationService {
    getInformationConfigs(key: string): Observable<MxInformationTooltipConfig>;
    getUserGuideLink(): string;
}

export const MX_INFORMATION_SERVICE_TOKEN = new InjectionToken<MxInformationService>('MX_INFORMATION_SERVICE_TOKEN');
